<template>
  <DxPopup
    class="popup-nutritional-balance"
    :visible="true"
    :show-close-button="true"
    title="Balance Nutricional"
    height="auto"
    @hiding="onClose"
  >
    <div class="popup-nutritional-balance__content">
      <div class="popup-nutritional-balance__body">
        <DxDataGrid
          :key="keyGridDosages"
          class="data-grid-dosage-product"
          :data-source="[nutritionProduct]"
          :show-borders="true"
        >
          <DxPaging :enabled="false" />
          <DxColumn
            data-field="name"
            :caption="$t('dosageProduct.uf')"
            :allow-sorting="false"
          />
          <DxColumn
            :caption="$t('dosageProduct.n') + ' (% P/P)'"
            data-field="n"
            data-type="number"
            :allow-sorting="false"
          />
          <DxColumn
            :caption="$t('dosageProduct.p') + ' (% P/P)'"
            data-field="p"
            data-type="number"
            :allow-sorting="false"
          />
          <DxColumn
            :caption="$t('dosageProduct.k') + ' (% P/P)'"
            data-field="k"
            data-type="number"
            :allow-sorting="false"
          />
          <DxColumn
            :caption="$t('dosageProduct.c') + ' (% P/P)'"
            data-field="c"
            data-type="number"
            :allow-sorting="false"
          />
          <DxColumn
            :caption="$t('dosageProduct.m') + ' (% P/P)'"
            data-field="m"
            data-type="number"
            :allow-sorting="false"
          />
          <DxColumn
            :caption="$t('dosageProduct.s') + ' (% P/P)'"
            data-field="s"
            data-type="number"
            :allow-sorting="false"
          />
        </DxDataGrid>
      </div>
      <div class="popup-nutritional-balance__footer">
        <div class="popup-nutritional-balance__footer__content">
          <button class="standard-blue-btn" @click="onClose">Volver</button>
        </div>
      </div>
    </div>
  </DxPopup>
</template>

<script>
import DxPopup from "devextreme-vue/popup";
import { DxDataGrid, DxColumn, DxPaging } from "devextreme-vue/data-grid";
import DxPopover from "devextreme-vue/popover";

export default {
  name: "PopupNutritionalBalance",
  components: { DxPopup, DxDataGrid, DxColumn, DxPaging, DxPopover },
  props: {
    nutritionProduct: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      keyGridDosages: 0,
    };
  },
  methods: {
    onClose() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./PopupNutritionalBalance.scss";
</style>
